






















































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import InvestmentLineChart from "@/shared/components/charts/InvestmentLineChart.vue";
import InvestmentInstrumentPieChart from "@/shared/components/charts/InvestmentInstrumentPieChart.vue";
import InvestmentGenericLineGraph from "@/shared/components/charts/InvestmentGenericLineGraph.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import InvestWithDrivewealthWidget from "@/employee/components/investments/drivewealth/InvestWithDrivewealthWidget.vue";
import PreenrollmentWidget from "@/employee/components/investments/drivewealth/PreenrollmentWidget.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import UserPartnerContent from "@/employee/components/investments/drivewealth/UserPartnerContent.vue";
import PreenrollmentManagement from "@/shared/components/investments/drivewealth/PreenrollmentManagement.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import HsabInvestmentAccountRedirectLink from "@/shared/components/investments/HsabInvestmentAccountRedirectLink.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import {
  DrivewealthAccountManagementType,
  ChartPointDataType,
  DrivewealthAccountIdentifierArgs,
  DrivewealthAccountPerformance,
} from "@/shared/types";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useDrivewealthAccountPerformanceStore } from "@/shared/store/drivewealthAccountPerformance";
import AccountPerformanceForm from "@/employee/components/investments/drivewealth/AccountPerformanceForm.vue";
import InvestmentBalancePanel from "@/shared/components/investments/drivewealth/InvestmentBalancePanel.vue";

enum GraphType {
  balance,
  rateOfReturn,
  holdings
}

@Component({
  components: {
    AccountPerformanceForm,
    InvestmentBalancePanel,
    DrivewealthNavigation,
    InvestmentLineChart,
    InvestmentGenericLineGraph,
    InvestmentInstrumentPieChart,
    GenericLoadingSpinner,
    InvestWithDrivewealthWidget,
    RiskDisclaimer,
    UserPartnerContent,
    PreenrollmentWidget,
    PreenrollmentManagement,
    AccountTypeSubheader,
    HsabInvestmentAccountRedirectLink,
  },
  computed: {
    ChartPointDataType () {
      return ChartPointDataType;
    },
    GraphType () {
      return GraphType;
    }
  }
})
export default class DrivewealthAccountSummaryView extends Vue {
  drivewealthStore = useDrivewealthStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  signingDocumentStore = useSigningDocumentStore();
  custodianSettingsStore = useCustodianSettingsStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  drivewealthAccountPerformanceStore = useDrivewealthAccountPerformanceStore();

  DrivewealthAccountManagementType = DrivewealthAccountManagementType;
  formatCurrency = formatCurrency;
  selectedGraphType = GraphType.balance;

  graphTypeSelectOptions = [
    {
      text: "Balance",
      value: GraphType.balance,
    },
    {
      text: "Rate of Return",
      value: GraphType.rateOfReturn,
    },
    {
      text: "Allocations",
      value: GraphType.holdings,
    }
  ];

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: true })
  accountId: number;

  load (): void {
    this.drivewealthAccountPerformanceStore.setSelectedAccountId(this.accountId);
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({});
    this.drivewealthSweepStore.getSweepV2({});
    this.drivewealthWizardStore.loadExistingPreenrollment({});
    this.drivewealthWizardStore.loadAllowedInvestmentAccountTypes({});
    this.drivewealthStore.loadAccountSummariesV2({});
    this.drivewealthAccountPerformanceStore.getAccountPerformance(this.accountIdentifiers);
  }

  @Watch("accountId")
  reload (): void {
    this.setSelectedGraph(GraphType.balance);
    this.load();
  }

  mounted (): void {
    this.load();
  }

  get accountIdentifiers (): DrivewealthAccountIdentifierArgs {
    return {
      username: this.username,
      partnerId: this.partnerId,
      accountId: this.accountId
    };
  }

  get showLoadingSpinner (): boolean {
    return !this.isLoaded;
  }

  get accountPerformanceDataLoaded (): boolean {
    return this.drivewealthAccountPerformanceStore.accountPerformanceLoaded(this.accountIdentifiers);
  }

  get hasAccountPerformanceData (): boolean {
    return !this.accountPerformanceResult.emptyDataSetMessage;
  }

  get isLoaded (): boolean {
    return this.investmentDailyBalanceStore.isHsaBalanceAndThresholdLoaded &&
        this.drivewealthSweepStore.sweepLoaded &&
        this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get showPreenrollment (): boolean {
    return !this.investmentDailyBalanceStore.hasEnoughToOpenAccount &&
        this.drivewealthWizardStore.isAllowedToPreenroll;
  }

  get accountPerformanceResult (): DrivewealthAccountPerformance {
    return this.drivewealthAccountPerformanceStore.accountPerformanceResult(this.accountIdentifiers);
  }

  setSelectedGraph (graphType: GraphType): void {
    this.selectedGraphType = graphType;
  }
}
